module.exports = __webpack_public_path__ + "static/media/ic_hi_b3_fisdom.ef78cc9f.svg";